import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';

import { getAppStore } from '../../../../../src/app/AppStore';
import { getPersonalSpace } from '../../../../../src/personalSpace/actions/PersonalSpaceActions';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { MoveContentAction } from '../../../../content/services/MoveContentAction';
import { IResultWithDestinationProject } from '../../../../content/services/MoveToProjectAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { removeFromContentSelection } from '../../../actions/spaces/ContentExplorerSelectionActions';
import { MoveContentsAction, moveContentsSucceeded } from '../../../actions/spaces/MoveContentsAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function openMoveContentDialog(content: IContentInfo[]): Promise<IResultWithDestinationProject> {
  return MoveContentAction.confirmMoveContent(content);
}

export function* handleMoveContentAction(action: MoveContentsAction) {
  try {
    const mutableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.contentArray);
    getAppStore().dispatch(getPersonalSpace());
    yield call(openMoveContentDialog, mutableContentCopy);
    yield put(removeFromContentSelection(...action.contentArray));

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, action.contentArray);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
    yield put(moveContentsSucceeded());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
